import { Helmet } from "react-helmet-async";

interface SeoHeadProps {
  title: string;
  description: string;
  path: string; // e.g. "/faq"
  ogType?: "website" | "article" | "product";
  ogImage?: string; // absolute URL preferred
  jsonLd?: object | object[];
}

const SITE_URL = "https://frogknowsnatives.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-native-plant-garden-planner.png`;

/**
 * Per-route head: title, description, canonical, og:*, optional JSON-LD.
 * Overrides defaults set in index.html for JS-executing crawlers.
 */
const SeoHead = ({
  title,
  description,
  path,
  ogType = "website",
  ogImage = DEFAULT_OG_IMAGE,
  jsonLd,
}: SeoHeadProps) => {
  const url = `${SITE_URL}${path}`;
  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
